(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sticky-atc-bar"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__stickyAtcBarMobileInit) return;
    window.__stickyAtcBarMobileInit = true;

    var mobileQuery = window.matchMedia('(max-width: 767px)');

    function syncBuyNowDisabled(bar) {
      var atc = bar.querySelector('[data-add-to-cart]');
      var buyNow = bar.querySelector('[data-sticky-buy-now]');
      if (!atc || !buyNow) return;

      var apply = function () {
        if (atc.disabled) {
          buyNow.setAttribute('disabled', 'disabled');
          buyNow.setAttribute('aria-disabled', 'true');
        } else {
          buyNow.removeAttribute('disabled');
          buyNow.removeAttribute('aria-disabled');
        }
      };

      apply();
      new MutationObserver(apply).observe(atc, {
        attributes: true,
        attributeFilter: ['disabled']
      });
    }

    function setMobileBarHeight() {
      var bar = document.querySelector('.sticky-atc-bar-mobile');
      if (!bar || !mobileQuery.matches) return;

      var next = bar.offsetHeight + 'px';
      var current = document.documentElement.style.getPropertyValue('--sticky-atc-bar-height').trim();
      if (current !== next) {
        document.documentElement.style.setProperty('--sticky-atc-bar-height', next);
      }
    }

    function initBars() {
      document.querySelectorAll('[data-sticky-atc-mobile]').forEach(syncBuyNowDisabled);
      setMobileBarHeight();
    }

    document.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-sticky-buy-now]');
      if (!btn || btn.disabled) return;

      event.preventDefault();

      var form = btn.closest('form');
      if (!form) return;

      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var formData = new FormData(form);

      btn.setAttribute('aria-busy', 'true');

      fetch(root + 'cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' }
      })
        .then(function (response) {
          if (!response.ok) throw response;
          window.location.href = root + 'checkout';
        })
        .catch(function () {
          btn.removeAttribute('aria-busy');
          var checkoutInput = document.createElement('input');
          checkoutInput.type = 'hidden';
          checkoutInput.name = 'checkout';
          checkoutInput.value = '1';
          form.appendChild(checkoutInput);
          form.submit();
        });
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initBars);
    } else {
      initBars();
    }

    window.addEventListener('resize', setMobileBarHeight);
    new MutationObserver(setMobileBarHeight).observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['style']
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
